var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoTo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33692 6.70748L3.33693 6.70224L3.34097 3.48566C3.34199 2.67202 3.99957 2.02215 4.79587 2.02541L4.80147 2.02542L32.9608 1.9828C33.7725 1.98178 34.4176 2.63467 34.4124 3.42901L34.4124 3.43436L34.377 31.6012C34.376 32.4148 33.7184 33.0647 32.9221 33.0614L32.9167 33.0614L29.7002 33.0655C28.8884 33.0665 28.2306 32.3955 28.2484 31.5777C28.2484 31.5775 28.2484 31.5772 28.2484 31.577L28.6827 14.5332L28.7465 12.0301L26.9759 13.8006L6.12891 34.6476C5.55302 35.2235 4.63585 35.2221 4.06573 34.652L1.75039 32.3367C1.18027 31.7665 1.17887 30.8494 1.75476 30.2735L22.6018 9.42649L24.3723 7.65593L21.8692 7.71971L4.82223 8.15406L4.82028 8.15411C3.9988 8.17665 3.33161 7.52255 3.33692 6.70748Z",
    stroke: "black",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoTo);
export default __webpack_public_path__ + "static/media/go-to.eb71daa0368781a842a93f80591a11be.svg";
export { ForwardRef as ReactComponent };